import { Production } from '@features/productions';
import { Box, Button, Card, Flex, Inset, Text } from '@radix-ui/themes';

import { ProductionAvatar } from './ProductionAvatar';
import styles from './ProductionCard.module.css';

interface ProductionCardProps {
    production: Production;
    onSelected: (production: Production) => void;
}

export const ProductionCard = ({
    production,
    onSelected,
}: ProductionCardProps) => {
    return (
        <Card
            style={{ backgroundColor: 'transparent' }}
            className={styles.container}
            asChild
        >
            <Button
                className={styles.button}
                variant={'outline'}
                onClick={() => onSelected(production)}
            >
                <Flex gap={'4'} align={'center'}>
                    <Inset clip={'padding-box'} side={'left'} p={'current'}>
                        <ProductionAvatar
                            production={production}
                            size={'7'}
                            radius={'none'}
                        />
                    </Inset>

                    <Box>
                        <Text color='gray' highContrast className={styles.name}>
                            {production.name}
                        </Text>
                    </Box>
                </Flex>
            </Button>
        </Card>
    );
};
